import Component from "@base/js/component";

export default class IFrameWrapper extends Component {
  className = "iframe-wrapper";

  // Defines the element selector which will initialize this component
  static selector = ".iframe-wrapper";

  // Defines children that needs to be queried as part of this component
  static children = {
    usMapContainer: ".aca-state-viz",
    usMapLegendContainer: ".aca-state-legend",
    iframes: ["iframe"],
  };

  // Add aspect ratio to the iframe based on its size
  addAspectRatio(iframe) {
    const digitRegex = /^\d+$/;
    const width = iframe.getAttribute("width") || "";
    const height = iframe.getAttribute("height") || "";

    if (!width.match(digitRegex) || !height.match(digitRegex)) {
      return;
    }

    const widthValue = parseInt(width, 10);
    const heightValue = parseInt(height, 10);

    iframe.classList.add("has-aspect-ratio");
    iframe.style.setProperty(
      "--aspect-ratio",
      `${widthValue} / ${heightValue}`
    );
  }

  // Will be called upon component instantiation
  afterInit() {
    const { usMapContainer, usMapLegendContainer, iframes } = this.children;

    if (usMapContainer && usMapLegendContainer) {
      let counter = 0;
      let isMapUpdated = false;
      let isLegendUpdated = false;
      const checkIfMap = setInterval(() => {
        // update the height of svg map if existing
        const usMap = usMapContainer.querySelector("svg.the-us-map");
        const usMapLegend = usMapLegendContainer.querySelector("svg.legend");
        if (usMap && !isMapUpdated) {
          const width = usMap.getAttribute("width") || 600;
          const height = usMap.getAttribute("height") || 350;
          usMap.removeAttribute("width");
          usMap.removeAttribute("height");
          usMap.setAttribute("preserveAspectRatio", "xMidYMid meet");
          usMap.setAttribute("viewBox", `0 0 ${width} ${height}`);
          isMapUpdated = true;
        }
        if (usMapLegend && !isLegendUpdated) {
          const width = usMapLegend.getAttribute("width") || 500;
          const height = usMapLegend.getAttribute("height") || 150;
          usMapLegend.removeAttribute("width");
          usMapLegend.removeAttribute("height");
          usMapLegend.setAttribute("preserveAspectRatio", "xMidYMid meet");
          usMapLegend.setAttribute("viewBox", `0 0 ${width} ${height}`);
          isLegendUpdated = true;
        }
        counter += 1;

        // clear if 30 sec already pass or two are already updated
        if (counter >= 150 || (isMapUpdated && isLegendUpdated)) {
          clearInterval(checkIfMap);
        }
      }, 200);
    }

    if (iframes) {
      iframes.filter(Boolean).forEach((iframe) => {
        this.addAspectRatio(iframe);
      });
    }
  }
}

// Remove this line if this component is not intended
// to initialize on DOM load.
IFrameWrapper.init();
